import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

function* loadStockBalance(action) {
    const {
        data: {
                page,
                pageSize,
                orderBy,
                orderType,
                accessToken,
                filterObj,
                type,
                file_value_pdf,
                limit_export,
                location_visibility,
                material_visibility,
        },
    } = action.payload

    try {
        const res = yield call(
            axios.post,
            `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-isupply-stock-balance`,
            {
              page,
              pageSize,
              orderBy,
              orderType,
              filterObj,
              type,
              file_value_pdf,
              limit_export,
              material_visibility,
              location_visibility
            },
            { headers: { Authorization: `Bearer ${accessToken}` } },
          )
          yield put(actions.loadStockBalance.success(res.data, page))
    } catch (err) {
    console.log(err.message)
    yield put(actions.loadStockBalance.failure())
  }
}

function* loadStockBalanceIsDirty(action) {
  const {
      data: {
              page,
              pageSize,
              orderBy,
              orderType,
              accessToken,
              filterObj,
              type,
              file_value_pdf,
              limit_export,
              location_visibility,
              material_visibility,
      },
  } = action.payload

  try {
      const res = yield call(
          axios.post,
          `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-isupply-stock-balance-is-dirty`,
          {
            page,
            pageSize,
            orderBy,
            orderType,
            filterObj,
            type,
            file_value_pdf,
            limit_export,
            material_visibility,
            location_visibility
          },
          { headers: { Authorization: `Bearer ${accessToken}` } },
        )
        yield put(actions.loadStockBalanceIsDirty.success(res.data, page))
  } catch (err) {
  console.log(err.message)
  yield put(actions.loadStockBalanceIsDirty.failure())
}
}

function* exportStockBalance(action) {
    const {
      data: {
        page,
        pageSize,
        orderBy,
        orderType,
        accessToken,
        filterObj,
        type,
        file_value_pdf,
        limit_export,
        location_visibility,
        material_visibility,
      },
    } = action.payload
  
    try {
      const res = yield call(
        axios.post,
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-isupply-stock-balance`,
        {
            page,
            pageSize,
            orderBy,
            orderType,
            accessToken,
            filterObj,
            type,
            file_value_pdf,
            limit_export,
            location_visibility,
            material_visibility,
        },
        { headers: { Authorization: `Bearer ${accessToken}` } },
      )
      yield put(actions.exportStockBalance.success(res.data, page))
      const sftpPath = res.data.data
      const downloadRes = yield call(
        axios.post,
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/download-report`,
        { sftp_path: sftpPath },
        { headers: { Authorization: `Bearer ${accessToken}` }, responseType: 'blob' },
      )
      const ext = sftpPath.split('.').pop().toLowerCase()
      const mimeType = ext === 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const blob = new Blob([downloadRes.data], { type: mimeType })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = sftpPath.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    } catch (err) {
      console.log(err.message)
      yield put(actions.exportStockBalance.failure())
    }
  }

function* loadStockBalanceDetail(action)
{
    const {data: { id, accessToken}} = action.payload
    try {
        const res = yield call(
            axios.post,
            `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-isupply-stock-balance-by-id`,
            {
                id
            },
            { headers: { Authorization: `Bearer ${accessToken}` } },
          )
          yield put(actions.loadStockBalanceDetail.success(res.data))
    } catch (err) {
    console.log(err.message)
    yield put(actions.loadStockBalanceDetail.failure())
  }
}

function* loadStockBalanceDetailIsDirty(action)
{
    const {data: { id, accessToken}} = action.payload
    try {
        const res = yield call(
            axios.post,
            `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-isupply-stock-balance-is-dirty/detail`,
            {
                id
            },
            { headers: { Authorization: `Bearer ${accessToken}` } },
          )
          yield put(actions.loadStockBalanceDetailIsDirty.success(res.data))
    } catch (err) {
    console.log(err.message)
    yield put(actions.loadStockBalanceDetailIsDirty.failure())
  }
}

function* createStockBalance(action)
{
    const {
        data: {
            id,
            stock_date,
            plant_id,
            material_id,
            silo_no,
            qty,
            actual_qty,
            diff_qty,
            create_by_id,
            update_by_id,
            remark,
            accessToken,
        },
        loading,
    } = action.payload

    try {
        const res = yield call(
          axios.post,
          `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/create-isupply-stock-balance`,
          {
            id,
            stock_date,
            plant_id,
            material_id,
            silo_no,
            qty,
            actual_qty,
            diff_qty,
            create_by_id,
            update_by_id,
            remark,
            matching_name: "isupply-stock-balance",
            action_name: 'edit',
          },
          { headers: { Authorization: `Bearer ${accessToken}` } },
        )
        loading(res.data)
        yield put(actions.createStockBalance.success(res.data))
      } catch (err) {
        yield put(actions.createStockBalance.failure())
      }
}

function* createStockBalanceFromIsDirty(action)
{
    const {
        data: {
            id,
            create_stock_balance_list,
            accessToken,
        },
        loading,
    } = action.payload

    try {
        const res = yield call(
          axios.post,
          `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/create-isupply-stock-balance-from-is-dirty`,
          {
            id,
            create_stock_balance_list,
            matching_name: "isupply-stock-balance",
            action_name: 'edit',
          },
          { headers: { Authorization: `Bearer ${accessToken}` } },
        )
        loading(res.data)
        yield put(actions.createStockBalanceFromIsDirty.success(res.data))
      } catch (err) {
        yield put(actions.createStockBalanceFromIsDirty.failure())
      }
}

function* updateStockBalance(action)
{
    const {
        data: {
            id,
            qty,
            actual_qty,
            diff_qty,
            update_by_id,
            remark,
            accessToken,
        },
        loading,
    } = action.payload

    try {
        const res = yield call(
          axios.post,
          `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/update-isupply-stock-balance`,
          {
            id,
            qty,
            actual_qty,
            diff_qty,
            update_by_id,
            remark,
            matching_name: "isupply-stock-balance",
            action_name: 'edit',
          },
          { headers: { Authorization: `Bearer ${accessToken}` } },
        )
        loading(res.data)
        yield put(actions.updateStockBalance.success(res.data))
      } catch (err) {
        yield put(actions.updateStockBalance.failure())
      }
}

export default function* watchIsupplyStockBalance() {
    yield all([
        takeEvery(actions.LOAD_STOCK_BALANCE.REQUEST, loadStockBalance),
        takeEvery(actions.EXPORT_STOCKE_BALANCE.REQUEST, exportStockBalance),
        takeEvery(actions.CREAT_STOCK_BALANCE.REQUEST, createStockBalance),
        takeEvery(actions.LOAD_STOCK_BALANCE_DETAIL.REQUEST, loadStockBalanceDetail),
        takeEvery(actions.UPDATE_STOCK_BALANCE.REQUEST, updateStockBalance),
        takeEvery(actions.LOAD_STOCK_BALANCE_IS_DIRTY.REQUEST, loadStockBalanceIsDirty),
        takeEvery(actions.LOAD_STOCK_BALANCE_DETAIL_IS_DIRTY.REQUEST, loadStockBalanceDetailIsDirty),
        takeEvery(actions.CREAT_STOCK_BALANCE_FROM_IS_DIRTY.REQUEST, createStockBalanceFromIsDirty)
    ])
}
export {
    loadStockBalance,
    exportStockBalance,
    loadStockBalanceDetail,
    createStockBalance,
    updateStockBalance,
    loadStockBalanceIsDirty,
    loadStockBalanceDetailIsDirty,
    createStockBalanceFromIsDirty
}